<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Order Details",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Order Details",
            items: [
               {
                  text: "Orders",
                  href: "/orders",
               },                
               
               {
                  text: "Details",
                  active: true,
               },                     
            ],

            order: {},
            payment: {},
            
            marker: { position: { lat: null, lng: null } },
            center: { lat: null, lng: null },

            mapOptions: {
               disableDefaultUI: true,
            },              
            token: '',
            errors: {},
            prescription_type:'',
            prescription_url:'',

         };
      },
      mounted() {
    
      },

      created() {
         this.fetchOrder();
      },

      methods: {

         getToken() {
         if (localStorage.getItem('sigohealth_admin')) {
            var sigohealth_admin =  JSON.parse(localStorage.getItem('sigohealth_admin'));
            if(sigohealth_admin.token) {
               this.token = sigohealth_admin.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
               
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
      },
         fetchOrder() {
            let url = "api/admin/pharmacy/order_details?order_id=" + this.$route.params.id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
               this.order = responseData.details; 
               this.payment = responseData.payment_details; 
               
               this.marker.position.lat = parseFloat(this.order.latitude);
               this.marker.position.lng = parseFloat(this.order.longitude);

               this.center.lat = parseFloat(this.order.latitude);
               this.center.lng = parseFloat(this.order.longitude);             
                     
            })
            .catch((error) => {
                  if (error.response) {
                     if (error.response.data.message) {
                        if(typeof error.response.data.message === 'object') {
                           console.log(error.response.status);
                        } else {
                           this.$swal("", error.response.data.message, "error");
                        }                        
                        
                     } else {
                        this.$swal("", "Something went wrong", "error");
                     }
                  } else {
                     this.$swal("", "Something went wrong", "error");
                  }
            })
            .finally(() => (this.loading = false));
         },

         showModal(modal) {
            this.$refs[modal].show();
         },

         hideModal(modal) {
            this.$refs[modal].hide();
         }, 
         viewPrescription (prescription) {
            this.prescription_type = prescription.prescription_type;
            this.prescription_url = prescription.prescription_url;
            console.log(this.prescription_url);
            this.showModal('view-prescription-modal');
         },  

        
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</a>
                        
                     </div>
                  </div>
                  <!----- top button area ends---->                  

                  <!---- listing table starts -------->
                  <div class="row">
                     <div class=" col-md-6 col-lg-6">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           
                           <div class="table-responsive">
                              <table class="table mb-0">
                                 
                                 <tbody>                                    
                                    
                                    <tr>
                                       <th>Order ID</th>
                                       <th>:</th>
                                       <td>{{order.id}}</td>
                                    </tr>              
                                    
                                    <tr>
                                       <th>Name</th>
                                       <th>:</th>
                                       <td>{{order.name}}</td>
                                    </tr>                         
                                    
                                    <tr>
                                       <th>Mobile</th>
                                       <th>:</th>
                                       <td>
                                          <span v-if="order.order_phone">
                                             {{order.order_country_code}} {{order.order_phone}}
                                          </span>
                                          <span v-else>
                                             {{order.profile_country_code}} {{order.profile_phone}}
                                          </span>
                                       </td>
                                    </tr>   

                                    <tr>
                                       <th>Email</th>
                                       <th>:</th>
                                       <td>{{order.email}}</td>
                                    </tr>                                   

                                    <tr>
                                       <th>Delivery Type</th>
                                       <th>:</th>
                                       <td>
                                          <span v-if="order.delivery_type==1">Regular</span>
                                          <span v-if="order.delivery_type==2">Express</span>
                                       </td>
                                    </tr>                                   

                                    <tr>
                                       <th>Delivery Date & Time</th>
                                       <th>:</th>
                                       <td>{{order.delivery_date + ' ' + order.delivery_time | formatDateTime}}</td>
                                    </tr>  

                                    <tr>
                                       <th>House Name/ FLat No.</th>
                                       <th>:</th>
                                       <td>{{order.flat}}</td>
                                    </tr>     

                                    <tr>
                                       <th>Delivery Address</th>
                                       <th>:</th>
                                       <td>{{order.address}}</td>
                                    </tr>

                                    <tr>
                                       <th>Pincode</th>
                                       <th>:</th>
                                       <td>{{order.pincode}}</td>
                                    </tr>

                                    <tr>
                                       <th>Private Delivery</th>
                                       <th>:</th>
                                       <td>
                                          <span v-if="order.private_delivery==1">Yes</span>
                                          <span v-else>No</span>
                                       </td>
                                    </tr>

                                    <tr>
                                       <th>Remarks</th>
                                       <th>:</th>
                                       <td>{{order.remarks}}</td>
                                    </tr>

                                    <tr>
                                       <th>Created by</th>
                                       <th>:</th>
                                       <td>
                                          <span v-if="order.added_by==1">Patient</span>
                                          <span v-if="order.added_by==2">Admin</span>
                                       </td>
                                    </tr>

                                    <tr>
                                       <th>Created on</th>
                                       <th>:</th>
                                       <td>{{order.converted_created_at}}</td>
                                    </tr>

                                    <tr>
                                       <th>Order Status</th>
                                       <th>:</th>
                                       <td>
                                          <span v-if="order.status==2">Placed</span>
                                          <span v-if="order.status==3">Paid</span>
                                          <span v-if="order.status==4">Dispatched</span>
                                          <span v-if="order.status==5">Completed</span>
                                          <span v-if="order.status==6">Cancelled</span>
                                       </td>
                                    </tr>

                                    <tr v-if="order.packed_at">
                                       <th>Packed on:</th>
                                       <th>:</th>
                                       <td>{{order.packed_at | formatDateTime}}</td>
                                    </tr>  

                                    <tr v-if="order.shipped_at">
                                       <th>Dispatched Date:</th>
                                       <th>:</th>
                                       <td>{{order.shipped_at | formatDateTime}}</td>
                                    </tr>  

                                    <tr v-if="order.delivered_at">
                                       <th>Completed Date:</th>
                                       <th>:</th>
                                       <td>{{order.delivered_at | formatDateTime}}</td>
                                    </tr>  

                                    <tr v-if="order.cancelled_at">
                                       <th>Cancelled Date:</th>
                                       <th>:</th>
                                       <td>{{order.cancelled_at | formatDateTime}}</td>
                                    </tr> 
                                 </tbody>
                              </table>
                           </div>
                        </b-card>

                                
                     </div>
                     <div class=" col-md-6 col-lg-6">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 p-3 mb-3">Order Summary</h4>
                           <div class="table-responsive">
                              <table class="table mb-0">
                                 
                                 <tbody>                                    
                                    
                                    <tr>
                                       <th>Amount</th>
                                       <th>:</th>
                                       <td style="text-align: right;">Rs. {{order.price}}</td>
                                    </tr>

                                    <tr v-if="order.discount">
                                       <th>Discount</th>
                                       <th>:</th>
                                       <td style="text-align: right;">- Rs. {{order.discount}}</td>
                                    </tr>

                                    <tr>
                                       <th>Delivery Charges</th>
                                       <th>:</th>
                                       <td style="text-align: right;">Rs. {{order.delivery_charge}}</td>
                                    </tr>

                                    <tr>
                                       <th>Total</th>
                                       <th>:</th>
                                       <td style="text-align: right;">Rs. {{order.total}}</td>
                                    </tr>
                                 </tbody>
                              </table>
                           </div>
                        </b-card>  

                        <b-card header-class="bg-transparent border-light" class="border border-light" v-if="payment">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 p-3 mb-3">Payment Details</h4>
                           <div class="table-responsive">
                              <table class="table mb-0">
                                 <tbody>
                                    <tr>
                                       <th>Payment Type</th>
                                       <th>:</th>
                                       <td>{{payment.payment_type}}</td>
                                    </tr>

                                    <tr v-if="payment.payment_id">
                                       <th>Payment ID</th>
                                       <th>:</th>
                                       <td>{{payment.payment_id}}</td>
                                    </tr>
                                    
                                 </tbody>
                              </table>
                           </div>
                        </b-card>
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4 class="font-size-18 bg-light  border border-top-0 border-start-0 border-end-0 p-3 mb-3">Prescriptions</h4>
                           <div v-if="order.prescription_notes" class="mb-5">
                              
                              <p>{{order.prescription_notes}}</p>
                           </div>

                           <ul class="list-inline p-0 m-0">                     
                              <li class="mb-3" v-for="(prescription, index) in order.prescriptions" :key="index">
                                 <!-- <a :href="$image_url + prescription.prescription_url" target="_blank" class="font-size-22"><p class="text-primary"><i class="fas fa-file-alt me-3"></i></p></a>   -->
                                 <div v-if="prescription.prescription_type==2"> 
                                          <!-- <img class="" src="@/assets/images/pdf.png" alt="PDF" > -->
                                       <a :href="$image_url + prescription.prescription_url" target="_blank" class="font-size-22"><p class="text-primary"><i class="fas fa-file-alt me-3"></i></p></a>  
                                       <!-- <a :href="$image_url + prescription.prescription_url" target="_blank" class="font-size-22">
                                          <img  :src="$image_url + prescription.prescription_url" alt
                                             class="avatar-sm me-4"></a>   -->

                                          <!-- <p class="text-primary"><i class="fas fa-file-alt me-3" v-b-modal.view-prescription-modal></i></p>   -->
                                       </div>
                                       <div  v-if="prescription.prescription_type==1"  v-bind:style="{ 'background-image': 'url(' + prescription.prescription_url + ')' }">
                                          <!-- <p class="text-primary"><i class="fas fa-file-alt me-3"  @click="viewPrescription(prescription)"></i></p>   -->

                                          <img  :src="$image_url + prescription.prescription_url" alt
                                             class="avatar-sm me-4" @click="viewPrescription(prescription)">
                                       </div>  
                              </li>
                              
                           </ul>
                        </b-card>


                        <b-card header-class="bg-transparent border-light" class="border border-light" v-if="order.latitude || order.longitude">
                           <h4 class="font-size-18 bg-light border border-top-0 border-start-0 border-end-0 p-3 mb-3">Location</h4>
                           <b-row>                          

                              <b-col  md="12">
                                 <GmapMap
                                 :center="center"
                                 :zoom="18"
                                 map-style-id="roadmap"
                                 :options="mapOptions"
                                 style="width: 100%; height: 300px"
                                 ref="mapRef">                              
                                    <GmapMarker
                                       :position="marker.position"
                                       :clickable="false"
                                       :draggable="false"                                    
                                    />
                              </GmapMap>        
                              </b-col>

                           </b-row>
                        </b-card>
                     </div>
                  </div>
                  <!---- listing table ends -------->
 <!---- modal starts ---->
 <b-modal ref="view-prescription-modal" id="view-prescription-modal" title="View Prescription" hide-footer>
                     <b-row>
                        
                        <b-col md="12" class="form-group">
                           <div class="prescription-images">
                              <ul>
                                 <li>
                                    <a :href="$image_url + this.prescription_url" target="_blank">
                                       <div class="file-pdf2" v-if="this.prescription_type==2"> 
                                          <img class="" src="@/assets/images/pdf.png" alt="PDF" >
                                       </div>
                                       <div class="file-img2" v-if="this.prescription_type==1"  v-bind:style="{ 'background-image': 'url(' + $image_url + this.prescription_url + ')' }">
                                          
                                       </div>   
                                    </a>
                                 </li>
                              </ul>
                           </div>
                        </b-col>
                        
                        <b-col md="12">
                           <b-button class="" variant="primary" @click="hideModal('view-prescription-modal')">Close</b-button>
                        </b-col>
                     </b-row>
                  </b-modal>
                  <!---- modal ends ----->
               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
